"use client";

import {
  Box,
  Flex,
  Avatar,
  HStack,
  Heading,
  Container,
  Text,
  IconButton,
  Button,
  Menu,
  MenuButton,
  MenuList,
  Image,
  MenuItem,
  MenuDivider,
  Input,
  useDisclosure,
  createIcon,
  useToast,
  Icon,
  Link,
  useColorModeValue,
  Stack,
} from "@chakra-ui/react";
import { HamburgerIcon, CloseIcon, AddIcon } from "@chakra-ui/icons";
import { BsArrowUpRight } from "react-icons/bs";
import { FiTwitter } from "react-icons/fi";
import logo from "../assets/logo.png";
import splash from "../assets/splash.jpg";
import { useForm } from "react-hook-form";
import jsonp from "jsonp"

const Links = ["Dashboard", "Projects", "Team"];

const NavLink = (props) => {
  const { children } = props;
  return (
    <Box
      as="a"
      px={2}
      py={1}
      rounded={"md"}
      _hover={{
        textDecoration: "none",
        bg: useColorModeValue("gray.200", "gray.700"),
      }}
      href={"#"}
    >
      {children}
    </Box>
  );
};

export default function LandingPage() {
  const { isOpen, onOpen, onClose } = useDisclosure();
    const toast = useToast();

    const {
      register,
      handleSubmit,
      formState: { errors },
    } = useForm();
  const submit = async (data) => {
    let { email } = data;
         toast({
           title: "Subsriber created.",
           description: "We've subscribe your account for you.",
           status: "success",
           duration: 9000,
           isClosable: true,
         });
        const url =
          "https://pindogo.us9.list-manage.com/subscribe/post?u=9fd38c951261ab70268f07145&amp;id=06f06bb9d9&amp;f_id=00b318e1f0";
        jsonp(`${url}&EMAIL=${email}`, { param: "c" }, (_, data) => {
    
        });
             toast({
               title: "Subsriber created.",
               description: "We've subscribe your account for you.",
               status: "success",
               duration: 9000,
               isClosable: true,
             });

    // const promise2 = loginUser({ login: email, password });
    // Promise.all([promise2])
    //   .then(function (values) {
    //     const promiseResolved = values?.[0]?.data;

    //     storeUserDetails(promiseResolved);

    //     setLoading(false);

    //     window.location.href = "/dashboard";
    //   })
    //   .catch((e) => {
    //     setLoading(false);
    //     errorNotifier(e?.response?.data?.message);
    //   });
  };

  return (
    <>
      <Box h={"100vh"} backgroundImage={splash} overflowY={"hidden"}>
        <Box
          //   bg={useColorModeValue("gray.100", "gray.900")}

          bg={"rgb(0, 0, 0)"}
          // px={6}
          pt={8}
        >
          <Flex
            paddingX={["unset", 10, 10, 80]}
            h={16}
            alignItems={"center"}
            justifyContent={"space-between"}
          >
            <HStack spacing={8} alignItems={"center"}>
              <Flex
                // borderWidth={1}
                // borderColor={"#66666680"}
                borderRadius={"10px"}
                // h={40}
                // w={44}
                h={[24, 34, 34, 40]}
                w={[28, 38, 38, 44]}
                paddingX={4}
              >
                {" "}
                <Image alt={"Login Image"} objectFit={"cover"} src={logo} />
              </Flex>
              <HStack
                as={"nav"}
                spacing={4}
                display={{ base: "none", md: "flex" }}
              ></HStack>
            </HStack>
            <Flex alignItems={"center"}>
              {/* <FiTwitter size={"1.5em"} color="#fff" /> */}
              <Link
                //   variant={"solid"}
                _hover={{ bg: "#ffffff40", color: "#fff" }}
                borderRadius={"10px"}
                href={"/login"}
                bg={"#fff"}
                px={4}
                py={2}
                color={"rgb(0, 0, 0)"}
                //   colorScheme={"#fff"}
                size={"sm"}
                mr={4}
                rightIcon={<BsArrowUpRight />}
              >
                Login
              </Link>
            </Flex>
          </Flex>

          {isOpen ? (
            <Box pb={4} display={{ md: "none" }}>
              <Stack as={"nav"} spacing={4}>
                {Links.map((link) => (
                  <NavLink key={link}>{link}</NavLink>
                ))}
              </Stack>
            </Box>
          ) : null}
        </Box>
        <Box p={6}>
          {" "}
          <Container maxW={"3xl"}>
            <Stack
              as={Box}
              textAlign={"center"}
              spacing={{ base: 8, md: 14 }}
              py={{ base: 10, md: 18 }}
            >
              <Heading
                fontWeight={600}
                color={"#fff"}
                fontSize={{ base: "2xl", sm: "4xl", md: "6xl" }}
                lineHeight={"110%"}
              >
                Get early access to <br />
                <Text color={"#fff"} as={"span"}>
                  Pindogo Today
                </Text>
              </Heading>
              <Text color={"#BABABA"}>
                Discover a new of social media appand Be Prepared for an
                Exciting Wave of New <br />
                Resources on the Horizon. Sign up to get invited to our mobile
                app!
              </Text>
              {/* <Stack
                direction={"row"}
                as="form"
                onSubmit={handleSubmit(submit)}
                spacing={3}
                align={"center"}
                alignSelf={"center"}
                position={"relative"}
              > */}
              <Stack
                direction={"row"}
                as="form"
                onSubmit={handleSubmit(submit)}
                // spacing={3}
                align={"center"}
                alignSelf={"center"}
                position={"relative"}
              >
                <Input
                  // defaultValue="test@gm"
                  placeholder="Your Email Address"
                  py={6}
                  bg={"rgba(89, 89, 89, 0.6)"}
                  outline={"none"}
                  border={"none"}
                  borderRadius={"10px"}
                  color={"rgb(255, 255, 255)"}
                  type="email"
                  {...register("email", { required: true })}
                />
                <Button
                  bg={"#fff"}
                  _hover={{ bg: "#ffffff40", color: "#fff" }}
                  type="submit"
                  // rounded={"full"}
                  px={8}
                  py={6}
                  borderRadius={"10px"}
                  color={"rgb(0, 0, 0)"}
                >
                  Join Us!
                </Button>

                <Box>
                  <Icon
                    as={Arrow}
                    color={useColorModeValue("#fff", "#fff")}
                    w={71}
                    position={"absolute"}
                    right={-71}
                    top={"10px"}
                  />
                  {/* <Text
                  fontSize={"lg"}
                  fontFamily={"Caveat"}
                  position={"absolute"}
                  right={"-125px"}
                  top={"-15px"}
                  color={"#fff"}
                  transform={"rotate(10deg)"}
                >
                  Starting at $15/mo
                </Text> */}
                </Box>
              </Stack>

              <Stack
                mt={8}
                direction={"row"}
                spacing={3}
                align={"center"}
                alignSelf={"center"}
                alignItems={'center'}
                justifyContent={'center'}
                position={"relative"}
                borderWidth={1}
                borderColor={"rgba(255, 255, 255, .22)"}
                borderRadius={"10px"}
                p={2}
              >
                <Text align={"center"} mt={2} alignSelf={"center"} color={"#BABABA"}>
                  Sign Up now & Get a Chance to explore our new social Media
                  app.
                </Text>

                <Box>
                  <Link
                    bg={"#ffffff40"}
                    // rounded={"full"}
                    // px={4}
                    px={4}
                    py={2}
                    href={"/register"}
                    color={"#fff"}
                    //   py={6}
                    borderRadius={"10px"}
                    _hover={{ bg: "#F9F6EE", color: "rgb(0, 0, 0)" }}
                    //   color={"rgb(0, 0, 0)"}
                    rightIcon={<BsArrowUpRight />}
                  >
                    Register
                  </Link>
                </Box>
              </Stack>
            </Stack>
          </Container>
        </Box>
      </Box>
    </>
  );
}
const Arrow = createIcon({
  displayName: "Arrow",
  viewBox: "0 0 72 24",
  path: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.600904 7.08166C0.764293 6.8879 1.01492 6.79004 1.26654 6.82177C2.83216 7.01918 5.20326 7.24581 7.54543 7.23964C9.92491 7.23338 12.1351 6.98464 13.4704 6.32142C13.84 6.13785 14.2885 6.28805 14.4722 6.65692C14.6559 7.02578 14.5052 7.47362 14.1356 7.6572C12.4625 8.48822 9.94063 8.72541 7.54852 8.7317C5.67514 8.73663 3.79547 8.5985 2.29921 8.44247C2.80955 9.59638 3.50943 10.6396 4.24665 11.7384C4.39435 11.9585 4.54354 12.1809 4.69301 12.4068C5.79543 14.0733 6.88128 15.8995 7.1179 18.2636C7.15893 18.6735 6.85928 19.0393 6.4486 19.0805C6.03792 19.1217 5.67174 18.8227 5.6307 18.4128C5.43271 16.4346 4.52957 14.868 3.4457 13.2296C3.3058 13.0181 3.16221 12.8046 3.01684 12.5885C2.05899 11.1646 1.02372 9.62564 0.457909 7.78069C0.383671 7.53862 0.437515 7.27541 0.600904 7.08166ZM5.52039 10.2248C5.77662 9.90161 6.24663 9.84687 6.57018 10.1025C16.4834 17.9344 29.9158 22.4064 42.0781 21.4773C54.1988 20.5514 65.0339 14.2748 69.9746 0.584299C70.1145 0.196597 70.5427 -0.0046455 70.931 0.134813C71.3193 0.274276 71.5206 0.70162 71.3807 1.08932C66.2105 15.4159 54.8056 22.0014 42.1913 22.965C29.6185 23.9254 15.8207 19.3142 5.64226 11.2727C5.31871 11.0171 5.26415 10.5479 5.52039 10.2248Z"
      fill="currentColor"
    />
  ),
});
